module.exports = __webpack_public_path__ + "static/coupleSmilingMobile-7e1a17d060889846a621acd0a1ab9687.png";